module.exports = __webpack_public_path__ + "static/showcase_keepitorganized-5e7c5dddf6341639d4a1dd6284c696e5.mp4";